import formatCurrency from '../../../common/formatCurrency';
import inputCurrencyMask from '../../../common/inputCurrencyMask';

export const sliderMinPrice = document.querySelector('#search_min_price_history');
export const searchMinPrice = document.querySelector('#search_min_price');
export const textFieldMinPrice = document.querySelector('#min-price');
export const sliderMaxPrice = document.querySelector('#search_max_price_history');
export const searchMaxPrice = document.querySelector('#search_max_price');
export const textFieldMaxPrice = document.querySelector('#max-price');
const graphColsWrapper = document.querySelector('.price-graph-columns');

const stringToInt = str => parseInt(str.replace(/\D/g, ''));

export const currencyStyle = digit => `R$ ${formatCurrency(digit)}`;

const priceRange = async(window) => {
  const { document } = window;

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const city = pathParts[pathParts.length - 1];

  const queryParams = new URLSearchParams(window.location.search);
  const url = `/apartments/${city}/price_ranges?${queryParams.toString()}`;

  const response = await fetch(url);
  const data = await response.json();
  window.searchPagePriceRangeData = JSON.stringify(data.searchPagePriceRangeData);

  const priceRanges = JSON.parse(window.searchPagePriceRangeData);
  let firstRangeStr, step, maxQnt, ranges;
  if (priceRanges.ranges.length) {
    firstRangeStr = priceRanges.ranges[0].range.split('_');
    step = firstRangeStr[1] - firstRangeStr[0];
    maxQnt = priceRanges.ranges.map(pr => pr.quantity).reduce((a, b) => Math.max(a, b));
    ranges = priceRanges.ranges.filter(pr => {
      const range = pr.range.split('_');
      if ((range[0] >= priceRanges.lowest_price - step) && (range[1] <= priceRanges.highest_price + step)) {
        return true;
      }
      return false;
    });
  }

  const lowerAttrs = {
    min: priceRanges.lowest_price,
    max: priceRanges.highest_price,
    value: priceRanges.min_price &&
      (priceRanges.min_price > priceRanges.lowest_price)
      ? priceRanges.min_price
      : priceRanges.lowest_price
  };
  const upperAttrs = {
    min: priceRanges.lowest_price,
    max: priceRanges.highest_price,
    value: priceRanges.max_price &&
      (priceRanges.max_price < priceRanges.highest_price)
      ? priceRanges.max_price
      : priceRanges.highest_price
  };

  if (lowerAttrs.value > lowerAttrs.max) {
    lowerAttrs.value = lowerAttrs.max;
  }

  if (upperAttrs.value < upperAttrs.min) {
    upperAttrs.value = upperAttrs.min;
  }

  setAttributes(searchMinPrice, { value: priceRanges.min_price });
  setAttributes(searchMaxPrice, { value: priceRanges.max_price });
  setAttributes(sliderMinPrice, lowerAttrs);
  setAttributes(sliderMaxPrice, upperAttrs);

  if (priceRanges.lowest_price === priceRanges.highest_price) {
    const readOnlyAttr = { readonly: true };
    setAttributes(sliderMinPrice, readOnlyAttr);
    setAttributes(sliderMaxPrice, readOnlyAttr);
    setAttributes(textFieldMinPrice, readOnlyAttr);
    setAttributes(textFieldMaxPrice, readOnlyAttr);
  }

  function setAttributes(el, attrs) {
    Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]));
  }

  textFieldMinPrice.value = currencyStyle(lowerAttrs.value);
  textFieldMaxPrice.value = currencyStyle(upperAttrs.value);

  textFieldMinPrice.onblur = function(e) {
    if (e.target.readOnly) {
      return false;
    }
    const minIntValue = stringToInt(e.target.value);
    const maxIntValue = stringToInt(textFieldMaxPrice.value);
    sliderMinPrice.value = (minIntValue < lowerAttrs.min) ? lowerAttrs.min : minIntValue;
    searchMinPrice.value = (minIntValue < lowerAttrs.min) ? lowerAttrs.min : minIntValue;
    searchMaxPrice.value = sliderMaxPrice.value;
    if (minIntValue > maxIntValue) {
      textFieldMaxPrice.value = maxIntValue > upperAttrs.max
        ? currencyStyle(upperAttrs.max)
        : currencyStyle(maxIntValue);
    }
    if (minIntValue < lowerAttrs.min) {
      textFieldMinPrice.value = currencyStyle(lowerAttrs.min);
    }
    if (minIntValue > upperAttrs.max) {
      textFieldMinPrice.value = currencyStyle(upperAttrs.max);
    }
    updateSliderRange();
    updateColumnHighlight();
  };

  textFieldMaxPrice.onblur = function(e) {
    if (e.target.readOnly) {
      return false;
    }
    const maxIntValue = stringToInt(e.target.value);
    const minIntValue = stringToInt(textFieldMinPrice.value);
    sliderMaxPrice.value = (maxIntValue > upperAttrs.max) ? upperAttrs.max : maxIntValue;
    searchMaxPrice.value = (maxIntValue > upperAttrs.max) ? upperAttrs.max : maxIntValue;
    searchMinPrice.value = sliderMinPrice.value;
    if (maxIntValue < minIntValue) {
      textFieldMinPrice.value = minIntValue < lowerAttrs.min
        ? currencyStyle(lowerAttrs.min)
        : currencyStyle(minIntValue);
    }
    if (maxIntValue < lowerAttrs.min) {
      textFieldMaxPrice.value = currencyStyle(lowerAttrs.min);
    }
    if (maxIntValue > upperAttrs.max) {
      textFieldMaxPrice.value = currencyStyle(upperAttrs.max);
    }
    updateSliderRange();
    updateColumnHighlight();
  };

  inputCurrencyMask(textFieldMinPrice);
  inputCurrencyMask(textFieldMaxPrice);

  function updateSliderRange() {
    const lowerVal = parseInt(sliderMinPrice.value);
    const upperVal = parseInt(sliderMaxPrice.value);

    if (upperVal <= lowerVal) {
      const newValue = (upperVal - 1) < sliderMinPrice.min ? sliderMinPrice.min : (upperVal - 1);
      sliderMinPrice.value = newValue;
      textFieldMinPrice.value = currencyStyle(newValue);
    }

    if (lowerVal >= upperVal) {
      const newValue = (lowerVal + 1) > sliderMaxPrice.max ? sliderMaxPrice.max : (lowerVal + 1);
      sliderMaxPrice.value = newValue;
      textFieldMaxPrice.value = currencyStyle(newValue);
    }
  }

  sliderMaxPrice.oninput = function(e) {
    updateSliderRange();
    searchMaxPrice.value = e.target.value;
    searchMinPrice.value = sliderMinPrice.value;
    textFieldMaxPrice.value = currencyStyle(e.target.value);
    updateColumnHighlight();
  };

  sliderMinPrice.oninput = function(e) {
    updateSliderRange();
    searchMinPrice.value = e.target.value;
    searchMaxPrice.value = sliderMaxPrice.value;
    textFieldMinPrice.value = currencyStyle(e.target.value);
    updateColumnHighlight();
  };

  function renderGraphCols() {
    graphColsWrapper.innerHTML = '';
    const sliderContainer = document.querySelector('.price-range-slider-container');
    if (priceRanges.ranges.length < 5) {
      sliderContainer.style.height = 'auto';
      return false;
    } else {
      sliderContainer.style.height = '100px';
    }
    const colWidth = (graphColsWrapper.offsetWidth / ranges.length) - 1;
    const cols = ranges.map(r => `
        <div range="${r.range}" class="graph-col" style="height: ${(r.quantity * 100) / maxQnt}%; width: ${colWidth}px">
        </div>
      `).join('');
    graphColsWrapper.innerHTML = cols;
    updateColumnHighlight();
  }

  // eslint-disable-next-line no-undef
  $('#modalFilters').on('shown.bs.modal', renderGraphCols);
  window.addEventListener('resize', renderGraphCols);

  renderGraphCols();
};

export function updateColumnHighlight() {
  const cols = graphColsWrapper.querySelectorAll('.graph-col');
  cols.forEach(col => {
    const colRange = col.getAttribute('range').split('_');
    if (parseInt(colRange[0]) < sliderMinPrice.value || parseInt(colRange[1]) > sliderMaxPrice.value) {
      col.classList.add('out-range');
    } else {
      col.classList.remove('out-range');
    }
  });
}

export default priceRange;
